

































import PatientEventCard from '@/components/care-team-dashboard/PatientEventCard.vue'
import { PATIENT_STATS_PAGE_TYPES } from '@/utils/constants'
import { PATIENT_NOUN } from '@/constants/app-variables'

export default {
  components: {
    PatientEventCard,
  },
  props: {
    patientWithNewChangesEvents: {
      type: Array,
      required: true,
    },
    patientRecentNotesGroupByPatientId: {
      type: Object,
      required: true,
    },
    showPatientPhoto: {
      type: Boolean,
      default: false,
    },
    isGeneratingExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      patientStatsPageType: PATIENT_STATS_PAGE_TYPES.SUMMARY.key,
      patientNoun: PATIENT_NOUN,
    }
  },
}
